interface Props {
  contactEmail: string;
}

export function ErrorPage({ contactEmail }: Props) {
  return (
    <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
        <h2 className="text-xl font-semibold text-slate-900">
          This link is no longer valid
        </h2>
        <p className="mt-3 text-slate-700">
          The link you used is invalid or has expired.
        </p>
        {contactEmail ? (
          <p className="mt-3 text-slate-700">
            Please contact us at{' '}
            <a
              href={`mailto:${contactEmail}`}
              className="font-medium underline"
              style={{ color: 'var(--brand-color)' }}
            >
              {contactEmail}
            </a>{' '}
            to request a new link.
          </p>
        ) : (
          <p className="mt-3 text-slate-700">
            Please contact our support team to request a new link.
          </p>
        )}
      </div>
    </main>
  );
}
